/* generated by scripts/pack-graph-data.mjs — do not edit */
export const PACK_PATH = "assets/m.eb364ed19e97.bin";
export const PACK_KEY = "KGm11PFmKBkGZhdq66PHvntoRsCkEwwuWE4HM3pRRCU=";
